import { type ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export function BackLink(): ReactNode {
  return (
    <Link
      to="/progress"
      className="inline-flex items-center gap-xs text-xs text-text-tertiary hover:text-text-primary"
    >
      <ArrowLeft size={14} /> Volver al leaderboard
    </Link>
  );
}
